<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@3.0.0 pass.glb -k -u -s -t
-->

<script lang="ts">
	import type * as THREE from 'three';

	import type { Snippet } from 'svelte';
	import { T, type Props } from '@threlte/core';
	import { useGltf, useSuspense } from '@threlte/extras';

	let {
		fallback,
		error,
		children,
		ref = $bindable(),
		...props
	}: Props<THREE.Group> & {
		ref?: THREE.Group;
		children?: Snippet<[{ ref: THREE.Group }]>;
		fallback?: Snippet;
		error?: Snippet<[{ error: Error }]>;
	} = $props();

	const suspend = useSuspense();

	type GLTFResult = {
		nodes: {
			Cube001: THREE.Mesh;
			Cube001_1: THREE.Mesh;
		};
		materials: {
			GLASS: THREE.MeshStandardMaterial;
			pass_atlas: THREE.MeshStandardMaterial;
		};
	};

	const gltf = suspend(useGltf<GLTFResult>('/models/pass.glb'));
</script>

<T.Group bind:ref dispose={false} {...props}>
	{#await gltf}
		{@render fallback?.()}
	{:then gltf}
		<T.Group name="Cube" position={[0, 0.25, -0.03]}  scale={[0.54, 0.54, 0.0010]}>
			<T.Mesh
				name="Cube001"
				castShadow
				receiveShadow
				geometry={gltf.nodes.Cube001.geometry}
				material={gltf.materials.GLASS}
			/>
			<T.Mesh
				name="Cube001_1"
				castShadow
				receiveShadow
				geometry={gltf.nodes.Cube001_1.geometry}
				material={gltf.materials.pass_atlas}
			/>
		</T.Group>
	{:catch err}
		{@render error?.({ error: err })}
	{/await}

	{@render children?.({ ref })}
</T.Group>
